import Vue from "vue";

import PromotionCodeEntry from "./PromotionCodeEntry.vue";

export function load() {
    const selector = "promotion-code-entry";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PromotionCodeEntry, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
